module.exports = __webpack_public_path__ + "img/Info-icon.97a36846.svg";